import CardBody from 'components/Card/CardBody';
import { BodyS, HeadingSBold } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import DetailsRow from './DetailsRow';
import { hasPermission } from 'utils/permissions/permissions';
import CanPerform from 'components/CanPerform/CanPerform';
import Button from 'components/CustomButtons/Button';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import Card from 'components/Card/Card';
import React, { useMemo } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/accounts/accountDetailsSubpageStyle';
import { makeStyles } from '@material-ui/core';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IOrganizationAddressProps {
	editAdditionalInfo: () => void;
	account: types.organizations.IAccount;
	loggedUserType: string;
	accountsGovernorate: string;
}

const OrganizationAddress = ({
	editAdditionalInfo,
	account,
	loggedUserType,
	accountsGovernorate,
}: IOrganizationAddressProps) => {
	const classes = useStyles();

	const noAddress = useMemo(
		() =>
			!!account &&
			['region', 'city', 'way', 'house', 'apartment'].some(
				(key: string) => !account.accountDetails[key as keyof types.organizations.IAccountData]
			),
		[account]
	);

	return (
		<Card>
			<CardBody className={classes.additionalInfo}>
				<HeadingSBold color="primary-light">
					{translate('organization.details.organization.address')}
				</HeadingSBold>
				<DetailsRow label={translate('governorate')} value={accountsGovernorate} />
				<DetailsRow label={translate('region')} value={account.accountDetails.region} />
				<DetailsRow label={translate('city')} value={account.accountDetails.city} />
				<DetailsRow label={translate('way.number')} value={account.accountDetails.way} />
				<DetailsRow label={translate('house.number')} value={account.accountDetails.house} />
				<DetailsRow label={translate('apartment.number')} value={account.accountDetails.apartment} />
				<DetailsRow
					label={translate('landmark')}
					hideBorder={!hasPermission(loggedUserType, 'organization:edit-organization-address')}
					value={account.accountDetails.landmark}
				/>
				<CanPerform
					action="organization:edit-organization-address"
					yes={
						<div className={classes.additionalInfoButtonWrapper}>
							<Button
								color="tertiary-light"
								id="edit-organization-address-button"
								onClick={editAdditionalInfo}
							>
								{translate('edit')}
							</Button>
							<ConditionalRender show={noAddress}>
								<BodyS color="disabled-light">
									{translate('organization.details.provide.address')}
								</BodyS>
							</ConditionalRender>
						</div>
					}
				/>
			</CardBody>
		</Card>
	);
};

export default OrganizationAddress;
